<template>
  <section>
    <coozzy-card
      class="global-card no-top-border table-card">
      <div class="row align-items-center my-2">
        <div class="col-12 col-md-2 mb-2 mb-md-0">
          <coozzy-form-input
            ref="searchText"
            v-model="searchText"
            :placeholder="$t('message.generic.search')"
            @keyup="searchInputText()" />
        </div>
        <div class="col-12 col-md-2 mb-2 mb-md-0">
          <coozzy-multiselect
            v-if="categoryFilter.length > 0"
            v-model="searchCategories"
            :clear-on-select="false"
            :close-on-select="false"
            :custom-label="customLabelCategory"
            :multiple="true"
            :options="categoryFilter"
            :placeholder="$tc('message.onBoarding.devices.filter.category')"
            :preselect-first="false"
            :preserve-search="true"
            :taggable="false"
            :track-by="'value'"
            class="filter-inputs"
            @remove="filterComponentsList"
            @select="filterComponentsList" />
        </div>
      </div>
      <div
        v-if="source === 'property'"
        class="row mb-2">
        <div class="col-12 col-sm-6 custom-col-xxl-3 mt-2 mb-md-0">
          <label
            for="propertyValue"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.propertyValue') }}</label>
          <coozzy-form-input-numeric
            id="propertyValue"
            ref="propertyValue"
            v-model="localPropertyValue"
            type="number"
            class="mb-2"
            :disabled="true"
            :filter="'formatPrice'"
            :placeholder="$tc('message.onBoarding.investmentPlanning.propertyValue')"
            :is-decimal="true" />
        </div>
        <div class="col-12 col-sm-6 custom-col-xxl-3 mt-2 mb-md-0">
          <label
            for="totalBuildingValue"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.totalBuildingValue') }}</label>
          <coozzy-form-input-numeric
            id="totalBuildingValue"
            ref="totalBuildingValue"
            v-model="totalBuildingValue"
            type="number"
            class="mb-2"
            :disabled="true"
            :filter="'formatPrice'"
            :placeholder="$tc('message.onBoarding.investmentPlanning.totalBuildingValue')"
            :is-decimal="true" />
        </div>
        <div class="col-12 col-sm-6 custom-col-xxl-3 mt-2 mb-md-0">
          <label
            for="futurePropertyValue"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.futurePropertyValue') }}</label>
          <coozzy-form-input-numeric
            id="futurePropertyValue"
            ref="futurePropertyValue"
            v-model="futurePropertyValue"
            type="number"
            class="mb-2"
            :disabled="true"
            :filter="'formatPrice'"
            :placeholder="$tc('message.onBoarding.investmentPlanning.futurePropertyValue')"
            :is-decimal="true" />
        </div>
        <div class="col-12 col-sm-6 custom-col-xxl-3 mt-2 mb-md-0">
          <label
            for="futureTotalValueBuilding"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.futureTotalValueBuilding') }}</label>
          <coozzy-form-input-numeric
            id="futureTotalValueBuilding"
            ref="futureTotalValueBuilding"
            v-model="futureTotalValueBuilding"
            type="number"
            class="mb-2"
            :disabled="true"
            :filter="'formatPrice'"
            :placeholder="$tc('message.onBoarding.investmentPlanning.futureTotalValueBuilding')"
            :is-decimal="true" />
        </div>
      </div>
      <div
        v-if="source === 'building'"
        class="row mb-2">
        <div class="col-12 col-md-2 mt-2 mb-md-0">
          <label
            for="propertyValue"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.buildingValue') }}</label>
          <coozzy-form-input-numeric
            id="buildingValue"
            ref="buildingValue"
            v-model="localBuildingValue"
            type="number"
            class="mb-2"
            :disabled="readOnly || !hasInvestmentPlanRole"
            :filter="'formatPrice'"
            :is-decimal="true"
            :placeholder="$tc('message.onBoarding.investmentPlanning.buildingValue')"
            @input="debouncedCalculateAllCosts()"
            @blur="onBuildingValueBlur()" />
        </div>
        <div class="col-12 col-md-2 mt-2 mb-md-0">
          <label
            for="propertyValue"
            class="font-weight-normal">{{ $t('message.onBoarding.investmentPlanning.totalPercentage') }}</label>
          <coozzy-form-input
            id="totalPercentageComponents"
            ref="totalPercentageComponents"
            v-model="totalPercentageComponents"
            class="mb-2"
            type="number"
            :min="0"
            :disabled="true"
            :state="totalPercentageComponents > 100 ? false : null"
            :placeholder="$t('message.onBoarding.investmentPlanning.totalPercentage')" />
        </div>
      </div>
      <div class="row align-items-center mb-2">
        <div
          v-if="hasInvestmentPlanRole"
          class="col-md-2 col-sm-6 col-12">
          <coozzy-dropdown
            :text="selectedEntriesText"
            class="w-100"
            design="green"
            size="sm">
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('installationDate')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterInstallationDate') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('costs')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterCostComponent') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('percentage')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterDistributionPercent') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('measures')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterMeasures') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('plannedReplacement')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterPlannedReplacement') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('futureCostFactor')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterFutureCostFactor') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="bulkEditComponents('plannedCosts')">
              {{ $t('message.onBoarding.investmentPlanning.actions.enterPlannedCosts') }}
            </coozzy-dropdown-item>
            <coozzy-dropdown-item
              :disabled="selectedEntriesGlobal.length === 0"
              @click="deleteComponentsClicked">
              {{ $t('message.generic.delete') }}
            </coozzy-dropdown-item>
          </coozzy-dropdown>
        </div>
        <div
          v-if="hasInvestmentPlanRole"
          class="col-md-2 col-sm-6 col-12">
          <template v-if="selectAllVisibleEntries && nbrTotalOfHits > nbrPerPage && nbrTotalOfHits <= 1000">
            <coozzy-form-checkbox
              v-model="selectAllEntries"
              :initial="selectAllEntries"
              :class="'p-0 w-100 btn-height-auto'"
              name="selectAllEntries"
              button>
              {{
                selectAllEntries ? $t('message.generic.unselectHiddenEntries', {amount: nbrTotalOfHits}) : $t('message.generic.selectHiddenEntries', {amount: nbrTotalOfHits})
              }}
            </coozzy-form-checkbox>
          </template>
        </div>
        <div
          v-if="hasInvestmentPlanRole"
          class="offset-md-5 col-md-1 d-flex justify-content-end align-items-center">
          <div
            @click="openAssembleListModal()">
            <coozzy-filters-icon
              v-b-tooltip="{container: '#rowConfig', title: $t('message.generic.tooltipAssembleList')}" />
          </div>
        </div>
        <div
          class="col-md-2 col-sm-6 col-12 mt-2 mt-sm-0"
          :class="hasInvestmentPlanRole ? '' : 'offset-sm-6 offset-md-10'">
          <coozzy-form-select
            v-model="nbrPerPage"
            name="numberEntries">
            <option value="5">
              5 {{ $t('message.generic.entries') }}
            </option>
            <option value="10">
              10 {{ $t('message.generic.entries') }}
            </option>
            <option value="15">
              15 {{ $t('message.generic.entries') }}
            </option>
            <option value="20">
              20 {{ $t('message.generic.entries') }}
            </option>
            <option value="all">
              {{ $t('message.manageInterestedParties.filter.allEntries') }}
            </option>
          </coozzy-form-select>
        </div>
      </div>
      <div
        v-if="isBusy"
        class="text-center">
        <coozzy-spinner />
      </div>
      <b-table
        v-else
        id="componentsTable"
        ref="componentsTable"
        bordered
        hover
        responsive="true"
        stacked="md"
        select-mode="single"
        class="overflow-auto shadow"
        :fields="fields"
        :items="componentsList"
        :tbody-tr-class="rowClass">
        <template
          #head(checkbox)>
          <coozzy-form-checkbox
            v-if="hasInvestmentPlanRole"
            ref="header_checkbox"
            @change="(value) => { handleCheckboxesInsideTable(value) }" />
        </template>
        <template #head(description)>
          {{ $t('message.tableColumnHeadings.description') }}
        </template>
        <template #head(bkp)>
          {{ $t('message.tableColumnHeadings.bkp') }}
        </template>
        <template #head(component)>
          {{ $t('message.tableColumnHeadings.component') }}
        </template>
        <template #head(installation)>
          {{ $t('message.tableColumnHeadings.installation') }}
        </template>
        <template #head(lifeSpan)>
          {{ $t('message.tableColumnHeadings.lifeSpan') }}
        </template>
        <template #head(calculatedReplacement)>
          {{ $t('message.tableColumnHeadings.calculatedReplacement') }}
        </template>
        <template #head(costs)>
          {{ $t('message.tableColumnHeadings.costs') }}
        </template>
        <template #head(percentage)>
          %
        </template>
        <template #head(measures)>
          {{ $t('message.tableColumnHeadings.measures') }}
        </template>
        <template #head(plannedReplacement)>
          {{ $t('message.tableColumnHeadings.plannedReplacement') }}
        </template>
        <template #head(futureCostFactor)>
          {{ $t('message.tableColumnHeadings.futureCostFactor') }}
        </template>
        <template #head(plannedCosts)>
          {{ $t('message.tableColumnHeadings.plannedCosts') }}
        </template>
        <!-- Body -->
        <template
          #cell(checkbox)="data">
          <coozzy-form-checkbox
            v-if="((source === 'property' && data.item.referenceId.startsWith('prop')) || source === 'building') && hasInvestmentPlanRole"
            :id="'check_' + (data.item.id || data.item.internalId)"
            :key="'checkbox_' + (data.item.id || data.item.internalId)"
            v-model="data.item.selected"
            :initial="data.item.selected"
            @change="(value) => { itemSelectedGlobal(data.item, value) }" />
        </template>
        <template #cell(description)="data">
          <template v-if="data.item.referenceId.includes('prop_')">
            {{ $t('message.propertiesView.property') }} {{ getPropertyName() }}
          </template>
          <template v-if="data.item.referenceId.includes('building_')">
            {{ $t('message.onBoardingTabs.building') }}
            {{ data.item.referenceId ? getBuildingName(data.item.referenceId) : '' }}
          </template>
          <template v-if="data.item.referenceId.includes('obj_')">
            {{ $t('message.onBoarding.buildings.objects.titleObject') }}
            {{ data.item.referenceId ? getObjectName(data.item.referenceId) : '' }}
          </template>
        </template>
        <template #cell(bkp)="data">
          <coozzy-form-input
            :id="'bkpH_' + (data.item.id || data.item.internalId)"
            v-model="data.item.bkp"
            :is-read-only="readOnly"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="emitChanges(data.item)" />
        </template>
        <template #cell(component)="data">
          <coozzy-form-input
            :id="'type_' + (data.item.id || data.item.internalId)"
            v-model="data.item.name"
            :is-read-only="readOnly"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="emitChanges(data.item)" />
        </template>
        <template #cell(installation)="data">
          <coozzy-form-input
            :id="'installation_' + (data.item.id || data.item.internalId)"
            v-model="data.item.installationDateString"
            :is-read-only="readOnly"
            :filter="'formatDate'"
            type="date"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @blur="dateToObject(data.item)" />
        </template>
        <template #cell(lifeSpan)="data">
          <coozzy-form-input
            :id="'lifeSpan_' + (data.item.id || data.item.internalId)"
            v-model="data.item.lifeSpan"
            :is-read-only="readOnly"
            type="number"
            :min="0"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="calculateReplacementDate(data.item)" />
        </template>
        <template #cell(calculatedReplacement)="data">
          <coozzy-form-input
            :id="'calculatedReplacement_' + (data.item.id || data.item.internalId)"
            v-model="data.item.calculatedReplacement"
            :is-read-only="readOnly"
            type="number"
            :min="getYear(data.item.installationDateString)"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="calculateLifeSpan(data.item)" />
        </template>
        <template #cell(costs)="data">
          <coozzy-form-input-numeric
            :id="'costs_' + (data.item.id || data.item.internalId)"
            v-model="data.item.costs"
            type="number"
            :is-read-only="readOnly"
            :filter="'formatPrice'"
            placeholder="CHF"
            :is-decimal="true"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="calculateFieldsRelatedToCost(data.item)" />
        </template>
        <template #cell(percentage)="data">
          <coozzy-form-input-numeric
            :id="'percentage_' + (data.item.id || data.item.internalId)"
            v-model="data.item.percentage"
            type="number"
            :is-read-only="readOnly"
            :filter="'number'"
            placeholder="%"
            :is-decimal="true"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole || (data.item.installationDate && data.item.installationDate.year > currentYear)"
            @input="calculateCost(data.item)" />
        </template>
        <template #cell(measures)="data">
          <coozzy-form-input
            :id="'measures_' + (data.item.id || data.item.internalId)"
            v-model="data.item.note"
            :is-read-only="readOnly"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="emitChanges(data.item)" />
        </template>
        <template #cell(plannedReplacement)="data">
          <coozzy-form-input
            :id="'plannedReplacement_' + (data.item.id || data.item.internalId)"
            v-model="data.item.plannedReplacementDateString"
            :is-read-only="readOnly"
            :filter="'formatDate'"
            type="date"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @blur="dateToObject(data.item)" />
        </template>
        <template #cell(futureCostFactor)="data">
          <coozzy-form-input-numeric
            :id="'futureCostFactor_' + (data.item.id || data.item.internalId)"
            v-model="data.item.futurePercentage"
            :is-read-only="readOnly"
            type="number"
            filter="formatNumber"
            :min="0"
            :is-decimal="true"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="calculatePlannedCost(data.item)" />
        </template>
        <template #cell(plannedCosts)="data">
          <coozzy-form-input-numeric
            :id="'plannedCosts_' + (data.item.id || data.item.internalId)"
            v-model="data.item.plannedCosts"
            type="number"
            :is-read-only="readOnly"
            :filter="'formatPrice'"
            placeholder="CHF"
            :is-decimal="true"
            :allow-click-input-on-table="true"
            :disabled="(source === 'property' && !data.item.referenceId.startsWith('prop')) || !hasInvestmentPlanRole"
            @input="calculateFutureCostFactor(data.item)" />
        </template>
      </b-table>
      <b-pagination
        v-if="nbrPerPage !== 'all'"
        v-model="currentPage"
        :per-page="nbrPerPage"
        :total-rows="listComponents.length"
        align="center"
        class="mb-3" />
    </coozzy-card>
    <b-modal
      v-if="showCreateComponentModal"
      :id="'createComponentInvestmentModal'"
      ref="createComponentInvestmentModal"
      :title="$t('message.onBoarding.investmentPlanning.addComponent')"
      hide-footer
      no-close-on-backdrop>
      <template>
        <div class="col p-0">
          <b-table
            id="table-groups"
            ref="table-groups"
            :busy="loadingAddComponent"
            :fields="fieldsAddComponent"
            :items="listPropBuildObj"
            bordered
            class="mb-4"
            hover
            responsive="true"
            stacked="md">
            <!-- Busy state -->
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <coozzy-spinner />
              </div>
            </template>
            <template #head(category)>
              {{ $t('message.advertisement.objectCategory.name') }}
            </template>
            <template #head(name)>
              {{ $t('message.onBoarding.devices.description') }}
            </template>
            <!-- Body -->
            <template #cell(checkbox)="data">
              <coozzy-form-checkbox
                :id="data.item.id"
                @change="(value) => { itemSelected(data.item, value) }" />
            </template>
            <template #cell(category)="data">
              <template v-if="data.item.id.startsWith('building_')">
                {{ $t('message.generic.building') }}
              </template>
              <template v-else-if="data.item.id.startsWith('prop_')">
                {{ $t('message.propertiesView.tabs.property') }}
              </template>
              <template v-else-if="data.item.category && data.item.category !== 'UNDEFINED_CATEGORY'">
                {{ $t('message.onBoarding.buildings.objects.category.' + data.item.category.toLowerCase()) }}
              </template>
              <template v-else>
                -
              </template>
            </template>
            <template #cell(name)="data">
              {{ data.item.name }}
            </template>
          </b-table>
        </div>
        <div class="col p-0">
          <coozzy-button
            class="mb-0 border"
            design="transparent"
            size="small"
            @click="hideCreateComponentModal">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            :disabled="selectedEntries.length < 1"
            class="float-right mb-0"
            design="green"
            size="small"
            @click="createComponentClicked()">
            {{ $t('message.generic.add') }}
          </coozzy-button>
          <div class="d-flex float-right mr-3 mt-1">
            <coozzy-form-checkbox
              v-model="optionalValueEnhancingComponent"
              :initial="optionalValueEnhancingComponent"
              class="pr-0 mr-0"
              name="optionalValueEnhancingComponent" />
            <span class="align-self-center">
              {{ $t('message.onBoarding.investmentPlanning.optionalValueEnhancingComponent') }}
              <coozzy-info-circle-icon
                v-b-tooltip.hover.html="$t('message.onBoarding.investmentPlanning.tooltipOptionalValue')" />
            </span>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-if="showDeleteModal"
      :id="'confirmationModalDeleteComponents'"
      ref="confirmationModalDeleteComponents"
      no-close-on-backdrop
      hide-footer
      :title="$t('message.onBoarding.investmentPlanning.deleteModal.title')"
      @close="hideDeleteComponentModal">
      <template>
        <div class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.deleteModal.textComponentCosts') }}</p>
        </div>
        <div class="col p-0">
          <coozzy-button
            size="small"
            class="mb-0 border"
            design="transparent"
            @click="hideDeleteComponentModal">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            size="small"
            class="float-right mb-0"
            design="green"
            @click="deleteComponent()">
            {{ $t('message.generic.delete') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
    <b-modal
      v-if="showEditModal"
      :id="'editComponentsModal'"
      ref="editComponentsModal"
      no-close-on-backdrop
      hide-footer
      :title="titleEditModal"
      @close="hideEditComponentsModal">
      <template>
        <div
          v-if="editAction === 'installationDate'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterInstallationDate') }}</p>
          <coozzy-form-input
            v-model="newInstallationDate"
            type="date" />
        </div>
        <div
          v-if="editAction === 'costs'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterCostComponent') }}</p>
          <coozzy-form-input-numeric
            v-model="newCostComponent"
            type="number"
            filter="formatNumber"
            :min="0"
            :is-decimal="true" />
        </div>
        <div
          v-if="editAction === 'percentage'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterDistributionPercent') }}</p>
          <coozzy-form-input-numeric
            v-model="newPercentage"
            type="number"
            filter="formatNumber"
            :min="0"
            :is-decimal="true" />
        </div>
        <div
          v-if="editAction === 'measures'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterMeasures') }}</p>
          <coozzy-form-input
            v-model="newMeasures" />
        </div>
        <div
          v-if="editAction === 'plannedReplacement'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterPlannedReplacement') }}</p>
          <coozzy-form-input
            v-model="newPlannedReplacementDate"
            type="date" />
        </div>
        <div
          v-if="editAction === 'futureCostFactor'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterFutureCostFactor') }}</p>
          <coozzy-form-input-numeric
            v-model="newFuturePercentage"
            type="number"
            filter="formatNumber"
            :min="0"
            :is-decimal="true" />
        </div>
        <div
          v-if="editAction === 'plannedCosts'"
          class="col p-0">
          <p>{{ $t('message.onBoarding.investmentPlanning.subTitlesEditModal.enterPlannedCosts') }}</p>
          <coozzy-form-input-numeric
            v-model="newPlannedCosts"
            type="number"
            filter="formatNumber"
            :min="0"
            :is-decimal="true" />
        </div>
        <div class="col p-0 mt-3">
          <coozzy-button
            size="small"
            class="mb-0 border"
            design="transparent"
            @click="hideEditComponentsModal">
            {{ $t('message.generic.cancel') }}
          </coozzy-button>
          <coozzy-button
            size="small"
            class="float-right mb-0"
            design="green"
            @click="applyEditChanges()">
            {{ $t('message.generic.form.applyAdd') }}
          </coozzy-button>
        </div>
      </template>
    </b-modal>
    <assemble-list-modal
      ref="assembleListModal"
      modal-id="assembleListModal"
      :fields="selectedFields"
      :default-fields="dataFields"
      @save-fields="saveFields" />
  </section>
</template>

<script lang="ts">
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox.vue'
import CoozzyFormSelect from '@/framework/components/form/select/CoozzyFormSelect.vue'
import { routeChecks } from '@/mixins/routeChecks'
import { tables } from '@/mixins/tables'
import { user } from '@/mixins/user'
import { buildValueCounts } from '@/misc/utils/filterCounts'
import CoozzyCard from '@/framework/components/card/CoozzyCard.vue'
import CoozzyFormInput from '@/framework/components/form/input/CoozzyFormInput.vue'
import debounce from 'debounce'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner.vue'
import CoozzyDropdownItem from '@/framework/components/dropdown/CoozzyDropdownItem.vue'
import { componentUtils } from '@/mixins/componentUtils'
import { dateUtils } from '@/mixins/dateUtils'
import CoozzyButton from '@/framework/components/button/CoozzyButton.vue'
import { helper } from '@/types/helper'
import Vue from 'vue'
import CoozzyDropdown from '@/framework/components/dropdown/CoozzyDropdown.vue'
import CoozzyMultiselect from '@/framework/components/multiselect/CoozzyMultiselect.vue'
import CoozzyFormInputNumeric from '@/framework/components/form/input/CoozzyFormInputNumeric.vue'
import CoozzyInfoCircleIcon from '@/framework/components/icons/CoozzyInfoCircleIcon.vue'
import CoozzyFiltersIcon from '@/framework/components/icons/CoozzyFiltersIcon.vue'
import SearchApi from '@/misc/apis/SearchApi'
import AssembleListModal from '@/contact/components/AssembleListModal.vue'
import { InvestPlanComponent } from '@/types/api'

interface SelectableComponent extends InvestPlanComponent {
  selected: boolean;
  internalId: string;
  futurePercentageTouched?: boolean;
  plannedCostsTouched?: boolean;
  installationDateString?: string;
  plannedReplacementDateString?: string;
  calculatedReplacement?: number | string;
  modified?: boolean;
}

interface queryParams {
  view: string
  searchText?: string
  searchCategories?: string[]
}

export default Vue.extend({
  name: 'ComponentCosts',
  components: {
    AssembleListModal,
    CoozzyFiltersIcon,
    CoozzyInfoCircleIcon,
    CoozzyFormInputNumeric,
    CoozzyMultiselect,
    CoozzyDropdown,
    CoozzyButton,
    CoozzyDropdownItem,
    CoozzySpinner,
    CoozzyFormInput,
    CoozzyCard,
    CoozzyFormSelect,
    CoozzyFormCheckbox
  },
  mixins: [routeChecks, tables, user, componentUtils, dateUtils, helper],
  props: {
    property: {
      type: Object,
      default: null
    },
    building: {
      type: Object,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    components: {
      default: () => [],
      type: Array
    },
    buildingsList: {
      default: () => [],
      type: Array
    },
    objectsList: {
      default: () => [],
      type: Array
    },
    source: {
      type: String,
      default: 'property' // 'property', 'building'
    },
    filters: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isBusy: true,
      selectedEntries: [],
      nbrPerPage: '5' as string,
      currentPage: 1,
      fields: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell'
        }
      ],
      dataFields: [
        {
          key: 'description',
          label: this.$t('message.tableColumnHeadings.description'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'bkp',
          label: this.$t('message.tableColumnHeadings.bkp'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'component',
          label: this.$t('message.tableColumnHeadings.component'),
          thClass: 'align-middle width-15',
          tdClass: 'align-middle width-15',
          selected: true
        },
        {
          key: 'installation',
          label: this.$t('message.tableColumnHeadings.installation'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'lifeSpan',
          label: this.$t('message.tableColumnHeadings.lifeSpan'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'calculatedReplacement',
          label: this.$t('message.tableColumnHeadings.calculatedReplacement'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'costs',
          label: this.$t('message.tableColumnHeadings.costs'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'percentage',
          label: this.$t('message.tableColumnHeadings.percentage'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'measures',
          label: this.$t('message.tableColumnHeadings.measures'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'plannedReplacement',
          label: this.$t('message.tableColumnHeadings.plannedReplacement'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'futureCostFactor',
          label: this.$t('message.tableColumnHeadings.measures'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        },
        {
          key: 'plannedCosts',
          label: this.$t('message.tableColumnHeadings.measures'),
          thClass: 'align-middle',
          tdClass: 'align-middle',
          selected: true
        }
      ],
      selectedFields: [],
      selectedEntriesGlobal: [],
      selectAllVisibleEntries: false,
      selectAllEntries: false,
      searchText: '',
      debouncedFilterComponentsList: null,
      debouncedCalculateAllCosts: null,
      closed: false,
      typeSuggestInputProps: {
        id: 'autosuggest__input',
        placeholder: this.$t('message.onBoarding.devices.searchType'),
        class: 'custom-select allowClickInputOnTable form-control'
      },
      fieldsAddComponent: [
        {
          key: 'checkbox',
          label: '',
          thClass: 'th-checkbox',
          tdClass: 'align-middle border-right-0 checkbox-cell'
        },
        {
          key: 'category',
          label: this.$t('message.advertisement.objectCategory.name'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        },
        {
          key: 'name',
          label: this.$t('message.onBoarding.devices.description'),
          thClass: 'align-middle',
          tdClass: 'align-middle'
        }
      ],
      loadingAddComponent: false,
      showCreateComponentModal: false,
      allComponents: [],
      filteredSuggestions: [],
      shouldShowOnTop: false,
      listSharedObjects: [],
      showDeleteModal: false,
      showEditModal: false,
      editAction: '',
      newInstallationDate: '',
      newCostComponent: 0,
      newPercentage: 0,
      newMeasures: '',
      searchCategories: [],
      listBuildingsPercentage: [],
      listColoredItems: [],
      optionalValueEnhancingComponent: false,
      newPlannedReplacementDate: '',
      newFuturePercentage: '',
      newPlannedCosts: '',
      currentYear: new Date().getFullYear(),
      listComponents: [] as SelectableComponent[],
      modalHideHandler: null
    }
  },
  computed: {
    titleEditModal() {
      switch (this.editAction) {
        case 'installationDate':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titleInstallationDate')
        case 'costs':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titleCostComponent')
        case 'percentage':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titleDistributionPercent')
        case 'measures':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titleMeasures')
        case 'plannedReplacement':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titlePlannedReplacement')
        case 'futureCostFactor':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titleFutureCostFactor')
        case 'plannedCosts':
          return this.$t('message.onBoarding.investmentPlanning.titlesEditModal.titlePlannedCosts')
        default:
          return ''
      }
    },
    localBuildingValue: {
      get() {
        const value = this.building?.buildingValue
        return value !== null && value !== undefined && value !== '' ? value : 0
      },
      set(value) {
        this.$store.dispatch('onboarding/updateBuildingField',
          { field: 'buildingValue', value: value, dataType: 'number' })
      }
    },
    localPropertyValue: {
      get() {
        return this.listComponents.reduce((sum, component) => {
          if (component.optionalValueEnhancingComponent === false && (!component.installationDate || component.installationDate?.year <= this.currentYear)) {
            return sum + (parseFloat(component.costs) || 0)
          }
          return sum
        }, 0)
      },
      set(value) {
        this.$emit('property-value-changed', value)
      }
    },
    totalBuildingValue() {
      return this.listComponents.reduce((sum, component) => {
        if (!component.referenceId.includes('prop_') && component.optionalValueEnhancingComponent === false && (!component.installationDate || component.installationDate?.year <= this.currentYear)) {
          return sum + (parseFloat(component.costs) || 0)
        }
        return sum
      }, 0)
      // return this.buildingsList.reduce((sum, building) => {
      //   return sum + (parseInt(building.buildingValue) || 0)
      // }, 0)
    },
    futurePropertyValue() {
      return this.listComponents.reduce((sum, component) => {
        if (component.optionalValueEnhancingComponent === false) {
          return sum + (parseFloat(component.costs) || 0)
        }
        return sum
      }, 0)
    },
    futureTotalValueBuilding() {
      return this.listComponents.reduce((sum, component) => {
        if (!component.referenceId.includes('prop_') && component.optionalValueEnhancingComponent === false) {
          return sum + (parseFloat(component.costs) || 0)
        }
        return sum
      }, 0)
    },
    totalPercentageComponents() {
      const total = this.listComponents.reduce((acc, component) => {
        if (component.optionalValueEnhancingComponent || component.installationDate?.year > this.currentYear) {
          return acc
        }
        return acc + (component.percentage ? parseFloat(component.percentage) : 0)
      }, 0)
      return Math.round(total)
    },
    listPropBuildObj() {
      if (this.source === 'property') {
        return this.property ? [this.property] : []
      }
      return this.buildingsList.concat(this.objectsList)
    },
    selectedEntriesText() {
      const count = this.selectAllEntries && this.selectAllVisibleEntries ? this.nbrTotalOfHits : this.selectedEntriesGlobal.length
      return this.$t('message.generic.selectedEntries') + ':  ' + count
    },
    componentsList: {
      get() {
        let list = []
        if (this.listComponents && this.listComponents.length > 0) {
          list = this.listComponents
        }
        if (this.nbrPerPage !== 'all') {
          list = list.slice((this.currentPage - 1) * this.nbrPerPage, this.currentPage * this.nbrPerPage)
        }
        return list
      },
      set(value) {
        this.$emit('change-component', value)
      }
    },
    isFiltered() {
      return this.searchText !== '' || this.searchCategories.length > 0
    },
    categoryFilter() {
      if (this.allComponents.length === 0) {
        return []
      }
      const counts = [{
        count: this.allComponents.filter(x => x.referenceId.includes('prop_')).length,
        value: 'property'
      }, {
        count: this.allComponents.filter(x => x.referenceId.includes('building_')).length,
        value: 'building'
      }]
      counts.push(...buildValueCounts<string>(this.allComponents.map(obj => this.findObjectById(obj.referenceId)?.category), ['UNDEFINED_CATEGORY']))
      return counts
    },
    nbrTotalOfHits() {
      return this.source === 'property' ? this.listComponents.filter(comp => comp.referenceId.startsWith('prop_')).length : this.listComponents.length
    },
    selectedEntriesIds() {
      let list = this.listComponents
      if (this.source === 'property') {
        list = this.listComponents.filter(comp => comp.referenceId.startsWith('prop_'))
      }
      return this.selectAllEntries ? list.map(x => x.id || x.internalId) : this.selectedEntriesGlobal.map(obj => obj.id || obj.internalId)
    }
  },
  watch: {
    currentPage: function () {
      this.handleCheckboxesInsideTable(false)
      this.$refs.header_checkbox.checked = false
    },
    nbrPerPage: function (newVal) {
      localStorage.setItem('investmentPlanningTab-nbrPerPage', newVal)
    },
    components: {
      handler: function (newVal) {
        this.getComponents(newVal)
      }
    },
    categoryFilter: {
      handler: function (newVal) {
        if (newVal.length > 0) {
          if (this.filters && this.filters.searchCategories) {
            this.searchCategories = this.categoryFilter.filter(x => this.filters.searchCategories.some(y => y === x.value))
            this.filterComponentsList()
          } else {
            this.searchCategories = []
          }
        }
      }
    }
  },
  created() {
    // Initialize the debounced function in the created lifecycle hook
    this.debouncedFilterComponentsList = debounce(() => {
      this.filterComponentsList()
    }, 300)
    this.debouncedCalculateAllCosts = debounce(() => {
      this.calculateAllCosts()
    }, 300)
  },
  mounted: function () {
    this.modalHideHandler = (bvEvent, modalId) => {
      if (modalId === 'createComponentInvestmentModal') {
        if (this.$route.query && this.$route.query.addNewComponent) {
          const query = Object.assign({}, this.$route.query)
          delete query.addNewComponent
          this.$router.replace({ query })
        }
      }
    }
    this.$root.$on('bv::modal::hide', this.modalHideHandler)

    this.getComponents(this.components)

    this.nbrPerPage = localStorage.getItem('investmentPlanningTab-nbrPerPage') ? localStorage.getItem('investmentPlanningTab-nbrPerPage') === 'all' ? 'all' : parseInt(localStorage.getItem('investmentPlanningTab-nbrPerPage')) : 5
    SearchApi.loadSettings(this.accountId).then(response => {
      const settings = response.tableSettings
      let hasOldList = false
      if (settings.length > 0) {
        const table = this.source === 'property' ? 'investmentPlanningProperty' : 'investmentPlanningBuilding'
        settings.forEach(setting => {
          if (setting.columns.length > 0 && setting.table === table) {
            hasOldList = true
            this.loadFields(setting)
          }
        })
      }
      if (hasOldList === false) {
        this.fields.push(...this.dataFields.filter(x => x.selected))
        this.selectedFields = JSON.parse(JSON.stringify(this.dataFields))
      }
    }).catch(e => {
      console.log(e)
    })
    if (this.filters && this.filters.searchText) {
      this.searchText = this.filters.searchText
      this.filterComponentsList()
    } else {
      this.searchText = ''
    }
  },
  beforeDestroy() {
    if (this.modalHideHandler) {
      this.$root.$off('bv::modal::hide', this.modalHideHandler)
    }
  },
  methods: {
    filtersChanged() {
      const query = {} as queryParams
      if (this.searchText) {
        query.searchText = this.searchText
      }
      if (this.searchCategories && this.searchCategories.length > 0) {
        query.searchCategories = this.searchCategories.map(x => x.value)
      } else {
        query.searchCategories = []
      }
      this.$emit('filters-changed', this.isFiltered, query)
    },
    getComponents(list) {
      this.isBusy = true
      this.listComponents = list.map((item: InvestPlanComponent): SelectableComponent => {
        return this.prepareComponentRow(item)
      })
      this.allComponents = this.listComponents
      this.getListColoredItems()
      this.isBusy = false
    },
    prepareComponentRow(item: InvestPlanComponent): SelectableComponent {
      const component: SelectableComponent = {
        ...item,
        selected: false,
        internalId: (item as SelectableComponent).internalId || ''
      }
      if (!component.installationDateString && component.installationDate) {
        component.installationDateString = this.$options.filters.objectToDateInput(component.installationDate)
      }
      if (!component.plannedReplacementDateString && component.plannedReplacementDate) {
        component.plannedReplacementDateString = this.$options.filters.objectToDateInput(component.plannedReplacementDate)
      }
      component.calculatedReplacement = this.fillOutCalculatedReplacement(component)
      this.initializeLinkedFieldTouched(component)
      return component
    },
    loadFields(setting) {
      const result = this.getFields(this.dataFields, setting)
      this.fields = result?.fields
      this.selectedFields = result?.selectedFields
      this.$refs.componentsTable?.refresh()
    },
    saveFields(data) {
      const columns = data.filter(x => x.selected === true).map(y => y.key)
      const table = this.source === 'property' ? 'investmentPlanningProperty' : 'investmentPlanningBuilding'
      SearchApi.saveSettings(this.accountId, columns, table).then(response => {
        const setting = response.tableSettings
        if (setting && setting.columns.length > 0) {
          this.loadFields(setting)
        }
        this.$bvModal.hide('assembleListModal')
      })
    },
    openAssembleListModal() {
      this.$bvModal.show('assembleListModal')
    },
    isNumericFieldSet(value) {
      return value !== null && value !== undefined && value !== ''
    },
    initializeLinkedFieldTouched(component: SelectableComponent) {
      const isPersisted = Boolean(component.id) && !component.internalId
      if (!isPersisted) {
        component.futurePercentageTouched = false
        component.plannedCostsTouched = false
        return
      }
      const factorSet = this.isNumericFieldSet(component.futurePercentage)
      const plannedSet = this.isNumericFieldSet(component.plannedCosts)
      component.futurePercentageTouched = factorSet && component.futurePercentage !== 0
      component.plannedCostsTouched = plannedSet && component.plannedCosts !== 0
      if (factorSet && plannedSet && (component.futurePercentage === 0 || component.plannedCosts === 0)) {
        component.futurePercentageTouched = true
        component.plannedCostsTouched = true
      }
    },
    computePlannedCostsFromFuturePercentage(item) {
      const costs = parseFloat(item.costs)
      const futurePercentage = parseFloat(item.futurePercentage)
      if (!Number.isFinite(costs) || !Number.isFinite(futurePercentage)) {
        return null
      }
      return Math.round((costs * (1 + futurePercentage / 100)) * 20) / 20
    },
    syncPlannedCostsFromFutureFactor(item) {
      if (this.isNumericFieldSet(item.futurePercentage)) {
        item.plannedCosts = this.computePlannedCostsFromFuturePercentage(item)
      } else {
        item.plannedCosts = null
      }
    },
    syncFuturePercentageFromPlannedCosts(item) {
      if (this.isNumericFieldSet(item.plannedCosts)) {
        const costs = parseFloat(item.costs)
        if (!costs) {
          item.futurePercentage = null
        } else {
          item.futurePercentage = Math.round((((parseFloat(item.plannedCosts) - costs) / costs) * 100) * 20) / 20
        }
      } else {
        item.futurePercentage = null
      }
    },
    recalcLinkedFieldsIfTouched(item: SelectableComponent) {
      if (item.futurePercentageTouched) {
        this.syncPlannedCostsFromFutureFactor(item)
      } else if (item.plannedCostsTouched) {
        this.syncFuturePercentageFromPlannedCosts(item)
      }
    },
    calculatePlannedCost(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        const component = this.listComponents[componentIndex]
        component.futurePercentage = item.futurePercentage
        component.futurePercentageTouched = true
        this.syncPlannedCostsFromFutureFactor(component)
        this.emitChanges(component)
      }
    },
    calculateFutureCostFactor(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        const component = this.listComponents[componentIndex]
        component.plannedCosts = item.plannedCosts
        component.plannedCostsTouched = true
        this.syncFuturePercentageFromPlannedCosts(component)
        this.emitChanges(component)
      }
    },
    customLabelCategory(item) {
      if (item.value === 'property') {
        return this.$t('message.propertiesView.tabs.property') + ' (' + item.count + ')'
      }
      if (item.value === 'building') {
        return this.$t('message.generic.building') + ' (' + item.count + ')'
      }
      return this.$t('message.onBoarding.buildings.objects.category.' + item.value.toLowerCase()) + ' (' + item.count + ')'
    },
    hideEditComponentsModal() {
      this.$refs.editComponentsModal.hide()
      this.showEditModal = false
      this.editAction = ''
    },
    bulkEditComponents(type) {
      this.editAction = type
      this.showEditModal = true
      this.$nextTick(() => {
        this.$refs.editComponentsModal.show()
      })
    },
    async applyEditChanges() {
      if (this.editAction === 'installationDate') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.installationDate = this.toObject(this.newInstallationDate)
              component.installationDateString = this.newInstallationDate
              component.modified = true
              this.calculateReplacementDate(component)
            }
          })
        })
      } else if (this.editAction === 'costs') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.costs = this.newCostComponent
              component.modified = true
              this.calculateFieldsRelatedToCost(component)
            }
          })
        })
      } else if (this.editAction === 'percentage') {
        const buildingValue = this.source === 'property' ? this.localPropertyValue : this.localBuildingValue
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.percentage = this.newPercentage
              if (buildingValue > 0) {
                component.costs = Math.round((buildingValue * (parseFloat(this.newPercentage) / 100)) * 20) / 20
              }
              this.recalcLinkedFieldsIfTouched(component)
              component.modified = true
            }
          })
        })
      } else if (this.editAction === 'measures') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.note = this.newMeasures
              component.modified = true
            }
          })
        })
      } else if (this.editAction === 'plannedReplacement') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.plannedReplacementDate = this.toObject(this.newPlannedReplacementDate)
              component.plannedReplacementDateString = this.newPlannedReplacementDate
              component.modified = true
            }
          })
        })
      } else if (this.editAction === 'futureCostFactor') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.futurePercentage = this.newFuturePercentage
              component.futurePercentageTouched = true
              this.syncPlannedCostsFromFutureFactor(component)
              component.modified = true
            }
          })
        })
      } else if (this.editAction === 'plannedCosts') {
        this.selectedEntriesIds.forEach(id => {
          this.listComponents.forEach(component => {
            if (component.id && id ? component.id === id : component.internalId === id) {
              component.plannedCosts = this.newPlannedCosts
              component.plannedCostsTouched = true
              this.syncFuturePercentageFromPlannedCosts(component)
              component.modified = true
            }
          })
        })
      }
      this.$emit('change-component', this.listComponents)
      if (this.readOnly) {
        this.$emit('save-data')
      } else {
        this.emitChanges()
      }
      this.hideEditComponentsModal()
      this.handleCheckboxesInsideTable(false)
      this.$refs.header_checkbox.checked = false
    },
    showCreateComponentModalClicked() {
      this.showCreateComponentModal = true
      this.optionalValueEnhancingComponent = false
      this.$nextTick(() => {
        this.$refs.createComponentInvestmentModal.show()
      })
    },
    hideCreateComponentModal() {
      this.$refs.createComponentInvestmentModal.hide()
      this.optionalValueEnhancingComponent = false
      this.showCreateComponentModal = false
      this.selectedEntries = []
    },
    createComponentClicked() {
      this.loadingAddComponent = true
      this.$emit('component-added', this.selectedEntries, this.optionalValueEnhancingComponent)
      this.hideCreateComponentModal()
      this.loadingAddComponent = false
      // this.emitChanges()
    },
    initFilter() {
      this.searchText = ''
      this.searchCategories = []
    },
    dateToObject(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        this.listComponents[componentIndex].installationDate = this.toObject(this.listComponents[componentIndex].installationDateString)
        this.listComponents[componentIndex].plannedReplacementDate = this.toObject(this.listComponents[componentIndex].plannedReplacementDateString)
        this.calculateReplacementDate(item)
      }
    },
    getListColoredItems() {
      this.listColoredItems = this.listComponents.reduce((acc, component) => {
        const referenceId = component.referenceId
        if (!acc[referenceId]) {
          acc[referenceId] = []
        }
        acc[referenceId].push(component.id || component.internalId)
        return acc
      }, {})
    },
    rowClass(item, type) {
      if (type === 'row') {
        let indexColor = -1
        if (item.optionalValueEnhancingComponent) {
          return 'optionalValue'
        } else {
          Object.entries(this.listColoredItems).forEach(([key, value], index) => {
            const indexComp = (value as Array<string>).find((comp) => comp === item.id || comp === item.internalId)
            if (indexComp) {
              indexColor = index
            }
          })
          return indexColor % 2 === 0 ? '' : 'dark_line'
        }
      }
      return ''
    },
    calculateReplacementDate(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        this.listComponents[componentIndex].calculatedReplacement = this.fillOutCalculatedReplacement(this.listComponents[componentIndex])
        this.emitChanges(item)
      }
    },
    calculateLifeSpan(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        this.listComponents[componentIndex].lifeSpan = this.fillOutLifeSpan(this.listComponents[componentIndex])
        this.emitChanges(item)
      }
    },
    calculateCost(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      const buildingValue = this.source === 'property' ? this.localPropertyValue : this.localBuildingValue
      if (componentIndex !== -1 && this.isNumericFieldSet(item.percentage)) {
        const component = this.listComponents[componentIndex]
        component.percentage = item.percentage
        if (component.optionalValueEnhancingComponent === false && buildingValue > 0) {
          component.costs = Math.round((buildingValue * (parseFloat(component.percentage) / 100)) * 20) / 20
        }
        this.recalcLinkedFieldsIfTouched(component)
        this.emitChanges(component)
      }
    },
    calculateFieldsRelatedToCost(item) {
      const componentIndex = this.listComponents.findIndex(component => component.id && item.id ? component.id === item.id : component.internalId === item.internalId)
      if (componentIndex !== -1) {
        const component = this.listComponents[componentIndex]
        component.costs = item.costs
        const buildingValue = this.source === 'property' ? this.localPropertyValue : this.localBuildingValue
        if (component.optionalValueEnhancingComponent === false && buildingValue > 0) {
          component.percentage = Math.round(((parseFloat(component.costs) * 100) / buildingValue) * 20) / 20
        }
        this.emitChanges(component)
        this.calculatePropertyPercentage()
      }
    },
    findObjectById(id) {
      return this.objectsList.find(obj => obj.id === id)
    },
    findBuildingById(id) {
      return this.buildingsList.find(building => building.id === id)
    },
    filterComponentsList() {
      this.$nextTick(function () {
        this.listComponents = this.allComponents.filter(item => {
          const nameSearch = item.name ? item.name.toLowerCase().includes(this.searchText.toLowerCase()) : null
          const bkpHSearch = item.bkp ? item.bkp.includes(this.searchText.toLowerCase()) : null
          const categoryMapped = this.searchCategories.map(x => x.value)
          let cdtCategory
          if (item.referenceId.includes('prop_')) {
            cdtCategory = categoryMapped.includes('property') || this.searchCategories.length === 0
          } else if (item.referenceId.includes('building_')) {
            cdtCategory = categoryMapped.includes('building') || this.searchCategories.length === 0
          } else {
            cdtCategory = categoryMapped.includes(this.findObjectById(item.referenceId).category) || this.searchCategories.length === 0
          }
          let cdtNameObj
          if (item.referenceId.includes('prop_')) {
            cdtNameObj = this.property.name ? (this.property.name.toLowerCase()).includes(this.searchText.toLowerCase()) : null
          } else if (item.referenceId.includes('building_')) {
            cdtNameObj = this.findBuildingById(item.referenceId).name ? (this.findBuildingById(item.referenceId).name.toLowerCase()).includes(this.searchText.toLowerCase()) : null
          } else {
            cdtNameObj = this.findObjectById(item.referenceId).name ? (this.findObjectById(item.referenceId).name.toLowerCase()).includes(this.searchText.toLowerCase()) : null
          }
          return (bkpHSearch || nameSearch || cdtNameObj) && cdtCategory
        })
      })
      this.filtersChanged()
    },
    searchInputText() {
      this.debouncedFilterComponentsList()
      this.filtersChanged()
    },
    fillOutLifeSpan(item) {
      if (item.calculatedReplacement) {
        let date = new Date(item.installationDateString)
        return item.calculatedReplacement - date.getFullYear()
      }
      return ''
    },
    getYear(date) {
      if (date) {
        let d = new Date(this.$options.filters.objectToDateInput(date))
        return d.getFullYear()
      }
    },
    fillOutCalculatedReplacement(item) {
      if (item.installationDateString) {
        let date = new Date(item.installationDateString)
        return date.getFullYear() + (item.lifeSpan ? parseInt(item.lifeSpan) : 0)
      }
      return ''
    },
    getPropertyName() {
      return this.property ? this.property.name : ''
    },
    getBuildingName(id) {
      return (this.buildingsList.length > 0 && this.buildingsList.find(x => x.id === id)) ? this.buildingsList.find(x => x.id === id).name : ''
    },
    getObjectName(id) {
      return (this.objectsList.length > 0 && this.objectsList.find(x => x.id === id)) ? this.objectsList.find(x => x.id === id).name : ''
    },
    itemSelected(item, checked) {
      if (checked) {
        this.selectedEntries.push(item.id)
      } else {
        this.selectedEntries = this.selectedEntries.filter(entry => entry !== item.id)
      }
    },
    itemSelectedGlobal(item, checked) {
      this.componentsList.forEach((comp: SelectableComponent) => {
        if (comp.internalId && item.internalId ? comp.internalId === item.internalId : comp.id === item.id) {
          comp.selected = checked
        }
      })
      if (checked) {
        this.selectedEntriesGlobal.push(item)
        if (this.selectedEntries.length === this.nbrPerPage) {
          this.selectAllVisibleEntries = true
        }
      } else {
        this.selectedEntriesGlobal = this.selectedEntriesGlobal.filter(entry => item.internalId && entry.internalId ? entry.internalId !== item.internalId : entry.id && item.id ? entry.id !== item.id : false)
        this.selectAllEntries = false
        this.selectAllVisibleEntries = false
      }
    },
    handleCheckboxesInsideTable(value) {
      if (this.$refs.componentsTable) {
        const allCheckboxesComponents = this.$refs.componentsTable.$children[1].$children
        this.handleCheckbox(allCheckboxesComponents, value)
        this.selectAllVisibleEntries = value
      }
    },
    emitChanges(component) {
      if (component) {
        const index = this.listComponents.findIndex(c => c.id && component.id ? c.id === component.id : c.internalId === component.internalId)
        if (index !== -1) {
          component.modified = true
          this.$set(this.listComponents, index, component)
          this.$emit('change-component', component)
        }
      } else {
        this.$emit('change-component', this.listComponents)
      }
    },
    hideDeleteComponentModal() {
      this.$refs.confirmationModalDeleteComponents.hide()
      this.showDeleteModal = false
    },
    deleteComponentsClicked() {
      this.showDeleteModal = true
      this.$nextTick(() => {
        this.$refs.confirmationModalDeleteComponents.show()
      })
    },
    deleteComponent() {
      // separate new components and existing components
      const { internalIds, ids } = this.selectedEntriesIds.reduce((acc, id) => {
        if (typeof id === 'string' && id.startsWith('comp_')) {
          acc.ids.push(id)
        } else {
          acc.internalIds.push(id)
        }
        return acc
      }, { internalIds: [], ids: [] })

      if (internalIds.length > 0) {
        this.listComponents = this.listComponents.filter(component => !internalIds.includes(component.internalId))
        this.$emit('delete-new-component', internalIds)
        this.$nextTick(() => {
          if (this.listComponents.filter(x => x.id).length === 0 && this.listComponents.filter(x => x.internalId).length > 0) {
            this.$emit('save-data')
          }
        })
      }
      if (ids.length > 0) {
          this.$emit('delete-component', ids)
          this.hideDeleteComponentModal()
      } else {
        this.hideDeleteComponentModal()
      }
      // this.$emit('change-component', this.listComponents)
      this.handleCheckboxesInsideTable(false)
      this.selectedEntriesGlobal = []
    },
    parseNumericInputValue(raw) {
      if (raw === null || raw === undefined || raw === '') {
        return null
      }
      const parsed = parseFloat(String(raw).replace(/'/g, '').replace(',', '.'))
      return isNaN(parsed) ? null : parsed
    },
    normalizeBuildingValueForCompare(value) {
      if (value === null || value === undefined || value === '') {
        return null
      }
      const parsed = Number(value)
      return isNaN(parsed) ? null : parsed
    },
    buildingValuesEqual(a, b) {
      const normA = this.normalizeBuildingValueForCompare(a)
      const normB = this.normalizeBuildingValueForCompare(b)
      if (normA === null && normB === 0) {
        return true
      }
      if (normB === null && normA === 0) {
        return true
      }
      return normA === normB
    },
    resolveBuildingValueFromInput() {
      const parsedRef = this.parseNumericInputValue(this.$refs.buildingValue?.value)
      if (parsedRef !== null) {
        return parsedRef
      }
      const inputEl = this.$refs.buildingValue?.$el?.querySelector('input')
      const parsedInput = this.parseNumericInputValue(inputEl?.value)
      if (parsedInput !== null) {
        return parsedInput
      }
      if (this.localBuildingValue !== null && this.localBuildingValue !== undefined && this.localBuildingValue !== '') {
        return Number(this.localBuildingValue)
      }
      return 0
    },
    syncBuildingValueToStore() {
      if (this.source !== 'building') {
        return false
      }
      const valueToStore = this.resolveBuildingValueFromInput()
      if (this.buildingValuesEqual(valueToStore, this.building?.buildingValue)) {
        return false
      }
      this.$store.dispatch('onboarding/updateBuildingField', {
        field: 'buildingValue',
        value: valueToStore,
        dataType: 'number'
      })
      return true
    },
    onBuildingValueBlur() {
      if (this.source === 'building') {
        this.syncBuildingValueToStore()
      }
      this.calculateAllCosts()
    },
    calculateAllCosts() {
      if (this.source === 'building') {
        this.syncBuildingValueToStore()
      }
      const buildingValue = this.localBuildingValue || 0
      this.listComponents.forEach((component, index) => {
        if (component.optionalValueEnhancingComponent === false) {
          if (!component.installationDate || (component.installationDate && component.installationDate.year <= this.currentYear)) {
            if (buildingValue > 0 && this.isNumericFieldSet(component.percentage)) {
              component.costs = Math.round((buildingValue * (parseFloat(component.percentage) / 100)) * 20) / 20
            }
          }
        }
        this.recalcLinkedFieldsIfTouched(component)
        component.modified = true
        this.$set(this.listComponents, index, component)
      })
      this.$emit('change-component', this.listComponents)
    },
    calculatePropertyPercentage() {
      const buildingValue = this.source === 'property' ? this.localPropertyValue : (this.localBuildingValue || 0)
      if (buildingValue <= 0) return
      this.listComponents.forEach((component, index) => {
        if (component.referenceId.startsWith('prop') && component.optionalValueEnhancingComponent === false) {
          component.percentage = Math.round(((parseFloat(component.costs) * 100) / buildingValue) * 20) / 20
          this.listComponents[index].modified = true
        }
      })
      this.$emit('change-component', this.listComponents)
    }
  }
})
</script>

<style lang="scss" scoped>
.suggestion-container-bottom {
  position: absolute !important;
  background-color: white;
  z-index: 1000;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  top: 100%;
  left: 0;
  right: 0;
}

.suggestion-container-top {
  position: absolute !important;
  background-color: white;
  z-index: 1000;
  border: 1px solid #ddd;
  max-height: 200px;
  overflow-y: auto;
  bottom: 100%;
  left: 0;
  right: 0;
}
:deep(.dark_line) {
  background-color: #eee;
  td {
    background-color: #eee !important;
  }
}
:deep(.width-8) {
  width: 8%;
}
:deep(.width-15) {
  width: 15%;
}
:deep(.width-20) {
  width: 20%;
}
:deep(.optionalValue) {
  background-color: #FFF9E6;
  td {
    background-color: #FFF9E6 !important;
  }
}

@media (min-width: 1400px) {
  .custom-col-xxl-3 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 25%;
    flex: 0 0 25%;
    max-width: 25%
  }
}
</style>
